type StringMetadata = { context: string, english: string };

export const TokenizedStrings: Record<string, StringMetadata> = {
    CopyText: {
        context: "Displayed in tooltip of Copy buttons",
        english: "Copy"
    }
}